module.exports = __webpack_public_path__ + "static/media/icon.7f409dd9.png";